import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import {
  MULTIMEDIA_TYPES,
  AddMultimediaAction,
  GetAllMultimediaAction,
  GetOneMultimediaAction,
  EditMultimediaAction,
  DeleteMultimediaAction,
} from './multimediaTypes';
import * as Actions from './multimediaActions';
import { MultimediaApi } from '../api/multimediaApi';
import { MultimediaGetResponse } from '../model/multimediaModel';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';

function* addMultimediaSaga(add: AddMultimediaAction) {
  try {
    yield put(Actions.setApiMultimediaRequestState(API_REQUEST_STATE.LOADING));

    const response: AxiosResponse<MultimediaGetResponse> = yield call(MultimediaApi.post, add.payload.multimedia);

    yield put(Actions.getOneMultimediaSuccess(response.data));
    yield put(Actions.setApiMultimediaRequestState(API_REQUEST_STATE.SUCCEEDED_ADD));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiMultimediaRequestError(error.response.data.detail));
    yield put(Actions.setApiMultimediaRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

function* editMultimediaSaga(edit: EditMultimediaAction) {
  try {
    yield put(Actions.setApiMultimediaRequestState(API_REQUEST_STATE.LOADING));

    yield call(MultimediaApi.patch, edit.payload.params, edit.payload.multimedia);

    yield put(Actions.setApiMultimediaRequestState(API_REQUEST_STATE.SUCCEEDED_EDIT));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiMultimediaRequestError(error.response.data.detail));
    yield put(Actions.setApiMultimediaRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

function* deleteMultimediaSaga(edit: DeleteMultimediaAction) {
  try {
    yield put(Actions.setApiMultimediaRequestState(API_REQUEST_STATE.LOADING));

    yield call(MultimediaApi.delete, edit.payload.params);

    yield put(Actions.setApiMultimediaRequestState(API_REQUEST_STATE.SUCCEEDED_DELETE));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiMultimediaRequestError(error.response.data.detail));
    yield put(Actions.setApiMultimediaRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

function* getAllMultimediaSaga(getAll: GetAllMultimediaAction) {
  try {
    yield put(Actions.setApiAllMultimediaRequestState(API_REQUEST_STATE.LOADING));

    const response: AxiosResponse<MultimediaGetResponse[]> = yield call(
      MultimediaApi.getAll,
      getAll.payload.multimediaFilter,
    );

    yield put(Actions.setApiAllMultimediaRequestState(API_REQUEST_STATE.SUCCEEDED_GET));
    yield put(Actions.getAllMultimediaSuccess(response.data));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiAllMultimediaRequestError(error.response.data.detail));
    yield put(Actions.setApiAllMultimediaRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

function* getOneMultimediaSaga(getOne: GetOneMultimediaAction) {
  try {
    yield put(Actions.setApiMultimediaRequestState(API_REQUEST_STATE.LOADING));

    const response: AxiosResponse<MultimediaGetResponse> = yield call(MultimediaApi.getOne, getOne.payload.params);

    yield put(Actions.setApiMultimediaRequestState(API_REQUEST_STATE.SUCCEEDED_GET));
    yield put(Actions.getOneMultimediaSuccess(response.data));
  } catch (error) {
    // @ts-ignore
    yield put(Actions.setApiMultimediaRequestError(error.response.data.detail));
    yield put(Actions.setApiMultimediaRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

export default function* watch() {
  yield* [
    takeLatest(MULTIMEDIA_TYPES.ADD, addMultimediaSaga),
    takeLatest(MULTIMEDIA_TYPES.EDIT, editMultimediaSaga),
    takeLatest(MULTIMEDIA_TYPES.DELETE, deleteMultimediaSaga),
    takeLatest(MULTIMEDIA_TYPES.GET_ALL, getAllMultimediaSaga),
    takeLatest(MULTIMEDIA_TYPES.GET_ONE, getOneMultimediaSaga),
  ];
}
